import React from 'react';
import { Box, Container, Typography, Link, IconButton, Divider, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Instagram } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#000000',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} justifyContent="space-between">
          {/* Salon Info */}
          <Stack spacing={2} sx={{ flex: 1 }}>
            <Box sx={{ mb: 1 }}>
              <img src="/WhatsApp Image 2026-03-30 at 22.24.44.jpeg" alt="Desiree African Hair Braiding" style={{ height: 60 }} />
            </Box>
            <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
              {t('footer.tagline')}
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton
                aria-label="Instagram"
                sx={{ color: '#FFFFFF' }}
                size="small"
                component="a"
                href="https://www.instagram.com/desireeafricanbraiding/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram />
              </IconButton>
            </Stack>
          </Stack>

          {/* Quick Links */}
          <Stack spacing={1} sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ color: '#FFFFFF' }}>
              {t('footer.navigation')}
            </Typography>
            <Link component={RouterLink} to="/" sx={{ color: '#FFFFFF' }}>
              {t('footer.home')}
            </Link>
            <Link component={RouterLink} to="/services" sx={{ color: '#FFFFFF' }}>
              {t('footer.services')}
            </Link>
            <Link component={RouterLink} to="/booking" sx={{ color: '#FFFFFF' }}>
              {t('footer.book')}
            </Link>
            <Link component={RouterLink} to="/about" sx={{ color: '#FFFFFF' }}>
              {t('footer.about')}
            </Link>
            <Link component={RouterLink} to="/contact" sx={{ color: '#FFFFFF' }}>
              {t('footer.contact')}
            </Link>
          </Stack>

          {/* Contact Info */}
          <Stack spacing={1} sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ color: '#FFFFFF' }}>
              {t('footer.contactUs')}
            </Typography>
            <Typography variant="body2" sx={{ color: '#FFFFFF', whiteSpace: 'pre-line' }}>
              {t('footer.address')}
            </Typography>
            <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
              {t('footer.phone')}
              <br />
              {t('footer.email')}
              <br />
              {t('footer.instagram')}
            </Typography>
            <Typography variant="body2" sx={{ color: '#FFFFFF' }}>
              {t('footer.hours')}
            </Typography>
          </Stack>
        </Stack>

        <Divider sx={{ mt: 3, mb: 3 }} />

        <Typography variant="body2" sx={{ color: '#FFFFFF' }} align="center">
          &copy; {new Date().getFullYear()} Desiree African Hair Braiding. {t('footer.rights')}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
